import { render, staticRenderFns } from "./InboxNotification.vue?vue&type=template&id=7d02ac06&scoped=true&"
import script from "./InboxNotification.vue?vue&type=script&lang=js&"
export * from "./InboxNotification.vue?vue&type=script&lang=js&"
import style0 from "./InboxNotification.vue?vue&type=style&index=0&id=7d02ac06&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d02ac06",
  null
  
)

export default component.exports